export default {
    PARTNERS_REQUEST: 'partners/PARTNERS_REQUEST',
    PARTNERS_REQUEST_COMPLETED: 'partners/PARTNERS_REQUEST_COMPLETED',
    UPDATE_PARTNERS_REQUEST: 'partners/UPDATE_PARTNERS_REQUEST',
};
